export class XpressDisciplinaryChannelModel {
    public static XpressDisciplinaryChannelList: Array<any> = [
        { name: 'Facebook Messenger', value: 'Facebook Messenger' },
        { name: 'Twitter', value: 'Twitter' },
        { name: 'Instagram', value: 'Instagram' }
    ];
}
